import IPFSGatewayTools from '@pinata/ipfs-gateway-tools/dist/browser';
const gatewayTools = new IPFSGatewayTools();
export const gatewayUrl = (ipfs, gateway) => gatewayTools.convertToDesiredGateway(ipfs, gateway);
//# sourceMappingURL=gateway.js.map